/* Kuehn Doggear Theme: Warenkorb (Plus und Minus an der Menge, Formular sendet sich nach einer Aenderung selbst ab). */
(function () {
  'use strict';

  /* Im Theme-Editor kann das Skript mit dem Abschnitt erneut geladen werden: nur neu starten, nichts doppelt binden. */
  if (window.KuehnWarenkorb) {
    window.KuehnWarenkorb.start();
    return;
  }

  var WARTEZEIT = 600;

  function mengeStarten(wurzel) {
    wurzel.querySelectorAll('[data-menge]').forEach(function (menge) {
      var feld = menge.querySelector('[data-menge-feld]');
      var minus = menge.querySelector('[data-menge-minus]');
      var plus = menge.querySelector('[data-menge-plus]');
      if (!feld || !minus || !plus || menge.dataset.bereit) return;
      menge.dataset.bereit = 'ja';

      var min = parseInt(feld.min, 10);
      var max = parseInt(feld.max, 10);
      if (isNaN(min)) min = 1;

      function lesen() {
        var zahl = parseInt(feld.value, 10);
        return isNaN(zahl) ? min : zahl;
      }
      function abgleichen() {
        var zahl = lesen();
        minus.disabled = zahl <= min;
        plus.disabled = !isNaN(max) && zahl >= max;
      }
      function setzen(zahl) {
        if (zahl < min) zahl = min;
        if (!isNaN(max) && zahl > max) zahl = max;
        feld.value = String(zahl);
        abgleichen();
        feld.dispatchEvent(new Event('change', { bubbles: true }));
      }

      minus.addEventListener('click', function () { setzen(lesen() - 1); });
      plus.addEventListener('click', function () { setzen(lesen() + 1); });
      feld.addEventListener('input', abgleichen);
      abgleichen();
    });
  }

  /*
   * Bemerkung je Posten: als Eigenschaft (line item property) ueber /cart/change.js speichern.
   * change.js ersetzt alle Eigenschaften des Postens, darum werden die vorhandenen (data-eigenschaften)
   * uebernommen und nur die Bemerkung gesetzt. Gespeichert wird kurz nach dem Tippen und beim Verlassen.
   * Gibt eine Funktion zurueck, die alle offenen Bemerkungen speichert (vor Kasse und Mengenaenderung).
   */
  var BEMERKUNG_WARTEZEIT = 800;

  /* Liquid gibt item.properties | json als Liste von Paaren aus ([["Name","Wert"]]), cart.js als Objekt: beides zu einem Objekt */
  function eigenschaftenLesen(roh) {
    var ergebnis = {};
    if (Array.isArray(roh)) {
      roh.forEach(function (paar) {
        if (Array.isArray(paar) && paar.length >= 2 && typeof paar[0] === 'string') ergebnis[paar[0]] = paar[1];
      });
    } else if (roh && typeof roh === 'object') {
      Object.keys(roh).forEach(function (k) {
        /* Reste einer falschen Uebernahme (Schluessel "0", "1" …) verwerfen */
        if (/^\d+$/.test(k)) return;
        ergebnis[k] = roh[k];
      });
    }
    return ergebnis;
  }

  function bemerkungStarten(formular) {
    var felder = Array.prototype.slice.call(formular.querySelectorAll('[data-bemerkung]'));
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var zustaende = felder.map(function (feld) {
      var status = document.getElementById(feld.getAttribute('aria-describedby'));
      var eigenschaften = {};
      try { eigenschaften = eigenschaftenLesen(JSON.parse(feld.dataset.eigenschaften || '{}')); } catch (e) { eigenschaften = {}; }
      var z = { feld: feld, status: status, eigenschaften: eigenschaften, gespeichert: feld.value, timer: null, laeuft: null };

      function melden(art) {
        if (!status) return;
        status.removeAttribute('data-fehler');
        if (art === 'speichert') status.textContent = status.dataset.textSpeichert || '';
        else if (art === 'gespeichert') status.textContent = status.dataset.textGespeichert || '';
        else if (art === 'fehler') { status.textContent = status.dataset.textFehler || ''; status.setAttribute('data-fehler', ''); }
        else status.textContent = '';
      }

      z.speichern = function () {
        clearTimeout(z.timer);
        var wert = feld.value.trim();
        if (wert === z.gespeichert.trim()) return z.laeuft || Promise.resolve();
        /* Laeuft schon ein Speichern, danach den neuesten Stand nachziehen */
        if (z.laeuft) return z.laeuft.then(z.speichern);

        var neu = {};
        Object.keys(z.eigenschaften).forEach(function (k) { neu[k] = z.eigenschaften[k]; });
        /*
         * Leere Bemerkung: Eigenschaft weglassen. change.js ersetzt die Eigenschaften nur, wenn mindestens eine
         * mitkommt (ein leeres {} wird ignoriert); bleibt sonst keine uebrig, wird sie mit leerem Wert ueberschrieben.
         */
        if (wert) neu[feld.dataset.name] = wert;
        else {
          delete neu[feld.dataset.name];
          if (Object.keys(neu).length === 0) neu[feld.dataset.name] = '';
        }
        var zeile = parseInt(feld.dataset.zeile, 10);
        var mengeFeld = formular.querySelectorAll('[data-menge-feld]')[zeile - 1];
        var daten = { line: zeile, properties: neu };
        if (mengeFeld && !isNaN(parseInt(mengeFeld.value, 10))) daten.quantity = parseInt(mengeFeld.value, 10);

        melden('speichert');
        z.laeuft = fetch(wurzel + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(daten)
        }).then(function (antwort) {
          if (!antwort.ok) throw new Error('Status ' + antwort.status);
          return antwort.json();
        }).then(function (korb) {
          var posten = korb.items && korb.items[zeile - 1];
          if (posten && posten.properties) z.eigenschaften = eigenschaftenLesen(posten.properties);
          z.gespeichert = wert;
          melden('gespeichert');
        }).catch(function () {
          melden('fehler');
        }).then(function () {
          z.laeuft = null;
        });
        return z.laeuft;
      };

      feld.addEventListener('input', function () {
        if (status && status.textContent) melden('');
        clearTimeout(z.timer);
        z.timer = setTimeout(z.speichern, BEMERKUNG_WARTEZEIT);
      });
      feld.addEventListener('blur', function () { z.speichern(); });
      return z;
    });

    function alleSpeichern() {
      return Promise.all(zustaende.map(function (z) { return z.speichern(); }));
    }
    /* Gibt es eine Bemerkung, die noch nicht gespeichert ist oder gerade gespeichert wird? */
    alleSpeichern.offen = function () {
      return zustaende.some(function (z) {
        return !!z.laeuft || z.feld.value.trim() !== z.gespeichert.trim();
      });
    };
    return alleSpeichern;
  }

  function start(wurzel) {
    (wurzel || document).querySelectorAll('[data-warenkorb]').forEach(function (formular) {
      if (formular.dataset.bereit) return;
      formular.dataset.bereit = 'ja';
      mengeStarten(formular);
      var bemerkungenSpeichern = bemerkungStarten(formular);

      var timer = null;
      formular.addEventListener('change', function (e) {
        if (!e.target || !e.target.matches('[data-menge-feld]')) return;
        clearTimeout(timer);
        /* Kurz warten, damit mehrere Klicks auf Plus oder Minus zusammen abgeschickt werden */
        timer = setTimeout(function () {
          if (!formular.checkValidity()) {
            formular.reportValidity();
            return;
          }
          formular.setAttribute('aria-busy', 'true');
          /* Offene Bemerkungen zuerst speichern, sonst gingen sie mit dem Neuladen verloren */
          bemerkungenSpeichern().then(function () { formular.submit(); });
        }, WARTEZEIT);
      });

      /*
       * Kasse oder Aktualisieren: Ist keine Bemerkung offen, laeuft das Absenden ganz normal durch.
       * Sonst erst speichern, dann mit demselben Knopf erneut absenden. Das erneute Absenden kommt
       * per setTimeout erst nach dem laufenden submit-Ereignis: Waehrend der Browser ein Absenden
       * noch verarbeitet, verwirft er jedes weitere (requestSubmit bliebe wirkungslos, die Kasse
       * oeffnete sich nicht).
       */
      formular.addEventListener('submit', function (e) {
        if (formular.dataset.bemerkungenFertig) return;
        if (!bemerkungenSpeichern.offen()) return;
        e.preventDefault();
        var knopf = e.submitter || null;
        formular.setAttribute('aria-busy', 'true');
        bemerkungenSpeichern().then(function () {
          setTimeout(function () {
            formular.dataset.bemerkungenFertig = 'ja';
            if (formular.requestSubmit) formular.requestSubmit(knopf || undefined);
            else formular.submit();
            delete formular.dataset.bemerkungenFertig;
          }, 0);
        });
      });
    });
  }

  window.KuehnWarenkorb = { start: start };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  /* Kommt die Seite ueber "Zurueck" aus dem Browser-Speicher, ist sie nicht mehr beschaeftigt */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-warenkorb][aria-busy]').forEach(function (formular) {
      formular.removeAttribute('aria-busy');
    });
  });

  /* Im Theme-Editor neu geladene Abschnitte neu starten */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
